import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { DetailRow } from "./baseDetails";

export default function modelDataValueUpdateLstDeleteDetails({ row }) {
    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <DetailRow label="Removed Index">
                <span className="font-mono bg-red-50 text-red-700 px-2 py-0.5 rounded">{row.index}</span>
            </DetailRow>
        </ModelDataValueUpdateDetailsBase>
    );
}
